/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : April 30, 2025
Folder          : src/components/homepage/index
File            : Homepage.tsx
Description     : 
    This component allows the user to access the homepage of the web app.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/



// Import React Systems
import { useState } from 'react'

// Imports MUI Components
import {
  Box,
  Grid,
  Link,
  Stack,
  Card,
  CardMedia,
  CardContent,
  Button
} from "@mui/material"

import Text from "../../../atoms/text/Text"
import AccordionComp from "../../../atoms/accordion/AccordionComp"

import asianLife from "../../../../../assets/asianlife.png"
import avega from "../../../../../assets/avega.png"
import cocoLife from "../../../../../assets/cocolife.png"
import hmi from "../../../../../assets/hmi.png"
import intellicare from "../../../../../assets/intellicare.png"
import philCare from "../../../../../assets/philcare.png"
import lifeAndHealth from "../../../../../assets/lifeandhealth.png"
import dnc from "../../../../../assets/dnc.png"
import flexicare from "../../../../../assets/flexicare.png"
import kaiser from "../../../../../assets/kaiser.png"
import lacson from "../../../../../assets/lacson.png"
import hp from "../../../../../assets/hp.png"
import eastWest from "../../../../../assets/eastwest.png"
import etiqa from "../../../../../assets/etiqa.png"
import getWell from "../../../../../assets/getwell.png"
import inLife from "../../../../../assets/inlife.png"
import maxiCare from "../../../../../assets/maxicare.png"
import mediCard from "../../../../../assets/medicard.png"
import valuCare from "../../../../../assets/valucare.png"
import generali from "../../../../../assets/generali.png"

const Insurance = ({
  title,
  subtitle,
}) => {

  const gridStylesContainer = {
    backgroundColor: "transparent",
    justifyItems: "center",
    alignItems: "center",
    alignContent: "center",
    padding: {
      xs: "80px 20px 80px 20px", 
      sm: "80px 30px 80px 30px", 
      md: "80px 110px 80px 110px", 
      lg: "80px 110px 80px 110px", 
      xl: "80px 110px 80px 110px" 
    },
    width: "100%",
    "& .MuiGrid-item": {
      display: "flex",
      justifyContent: "center",
    },
  }

  const boxStylesWrapper = {
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "column",
  }
  
  const boxStylesContainer = {
    justifyContent: "center",
    borderRadius: "20px",
    backgroundColor: "transparent",
  }

  const cardStyleContainer = {
    height: "350px",
    alignContent: "center",
    textAlign: "center",
    borderRadius: "20px",
    backgroundColor: "#FEFEFE",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
    transition: "background-color 0.3s",
    "&:hover" : {
      backgroundColor: "rgba(46, 45, 45, 0.2)",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.4)",
    "& .card-media-zoom": {
      transform: "scale(1.05)",
      transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
    },
    }
  }

  const cardMediaStyles = {
    height: "250px",
    transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  }

  return (
    <>
      {/*Grids */}
      <Grid
        container
        rowSpacing={4}
        columnSpacing={6}
        sx={gridStylesContainer}
      >

        {/* Title Wrapper */}
        <Box
          sx={boxStylesWrapper}
        >

          <Stack 
            direction={"column"}
          >

            <Text
              text={title}
              variant="h2"/>

            <Box
            sx={{
              paddingLeft: ".7em",
              textIndent: "-0.7em",
            }}>
              <Text
                text={subtitle}
                variant="indexHeroH3"/>
            </Box>

          </Stack>
                        
        </Box>

        {/* Content */}
        {[
          { 
            img: asianLife,
            title: "Asian Life & General Assurance Corporation",
          },
          { 
            img: avega,
            title: "Avega",
          },
          { 
            img: cocoLife,
            title: "Cocolife Health Care",
          },
          { 
            img: dnc,
            title: "Dental Network Company",
          },
          { 
            img: eastWest,
            title: "EastWest Healthcare",
          },
          { 
            img: etiqa,
            title: "eTiQa Insurance",
          },
          { 
            img: flexicare,
            title: "Flexicare",
          },
          { 
            img: generali,
            title: "Generali",
          },
          { 
            img: getWell,
            title: "Get Well Health Systems",
          },
          { 
            img: hmi,
            title: "Health Maintenance Inc.",
          },
          { 
            img: hp,
            title: "Health Partners Dental Access, Inc.",
          },
          { 
            img: inLife,
            title: "InLife Insular Health Care",
          },
          { 
            img: intellicare,
            title: "Asian Life & General Assurance Corporation",
          },
          { 
            img: kaiser,
            title: "Kaiser International Health Group Inc.",
          },
          { 
            img: lacson,
            title: "Lacson & Lacson Insurance Brokers, Inc.",
          },
          { 
            img: lifeAndHealth,
            title: "Life and Health HMP, Incorporated",
          },
          { 
            img: maxiCare,
            title: "Maxicare",
          },
          { 
            img: mediCard,
            title: "MediCard",
          },
          { 
            img: philCare,
            title: "PhilCare",
          },
          { 
            img: valuCare,
            title: "ValuCare",
          },
          ].map((content) => (
                
          <Grid 
            size={{
              xs: 12,
              sm: 12,
              md: 12,
              lg: 4,
              xl: 4, 
            }}
            item
          >

            <Box
              sx={boxStylesContainer}
            >

              <Card
                elevation={0}
                sx={cardStyleContainer}
              >

                <CardMedia
                  component="img"
                  image={content.img}
                  sx={cardMediaStyles}
                  className="card-media-zoom"
                  alt="image"/>
                    
                <CardContent>

                  <Text
                    text={content.title}
                    variant="insuranceH3"/>

                </CardContent>
                            
              </Card>
            
            </Box>

          </Grid>

        ))}

      </Grid>
        
    </>
  )

}

export default Insurance;